import { apiCall, baseUrl, exportFileCall } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  getCatalogsMock,
  getCategoriesMock,
  getCoursesMock,
  getFfooMock,
  getHomeCoursesMock,
  getlevelsMock,
  setBookmarkMock,
  successMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { coursePath } from '../../utils/paths';

export default {
  getHomeCoursesList: (filters) => {
    if (shouldUseMock()) {
      return getHomeCoursesMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}highlight/course/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getCoursesList: (filters) => {
    if (shouldUseMock()) {
      return getCoursesMock(filters);
    }
    return apiCall(
      `${baseUrl}${coursePath}course/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  catalogsGet: () => {
    if (shouldUseMock()) {
      return getCatalogsMock();
    }
    return apiCall(`${baseUrl}${coursePath}catalog/list`, 'GET');
  },
  getCategories: (filters) => {
    if (shouldUseMock()) {
      return getCategoriesMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}category/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  globalCategoriesGet: () => {
    if (shouldUseMock()) {
      return getCategoriesMock();
    }
    return apiCall(`${baseUrl}${coursePath}global/category/list`, 'GET');
  },
  levelsGet: () => {
    if (shouldUseMock()) {
      return getlevelsMock();
    }
    return apiCall(`${baseUrl}${coursePath}level/list`, 'GET');
  },
  ffooGet: () => {
    if (shouldUseMock()) {
      return getFfooMock();
    }
    return apiCall(`${baseUrl}${coursePath}ffoo/list`, 'GET');
  },
  setBookmark: (id, action) => {
    if (shouldUseMock()) {
      return setBookmarkMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/bookmark`, 'POST', {
      action,
    });
  },
  getGlobalCoursesList: (filters) => {
    if (shouldUseMock()) {
      return getCoursesMock(filters);
    }
    return apiCall(
      `${baseUrl}${coursePath}global/course/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  globalCoursesListExport: (filters) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return exportFileCall({
      url: `${baseUrl}${coursePath}global/course/list/download${parseQueryParams(
        filters
      )}`,
      method: 'GET',
      filename: 'global_catalog.csv',
    });
  },
};
